import { useGetApiV1ThreeLetterCodeClientAdminsClient } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetClient = useGetApiV1ThreeLetterCodeClientAdminsClient;
